export default __webpack_public_path__ + "static/media/cloud_sql.e2d54bf5.svg";